import * as React from 'react';
export const usePreviousNextButtonsDisabledState = ({ tabBarRef, tabsRef, }) => {
    const [isPreviousButtonDisabled, setIsPreviousButtonDisabled] = React.useState(true);
    const [isNextButtonDisabled, setIsNextButtonDisabled] = React.useState(true);
    React.useEffect(() => {
        if (!tabBarRef.current && !tabsRef.current[0]) {
            return;
        }
        const firstTab = tabsRef.current[0];
        const lastTab = tabsRef.current[tabsRef.current.length - 1];
        const options = {
            root: tabBarRef.current,
            threshold: 0.99,
            rootMargin: '100% 0%',
        };
        const firstTabIntersectionObserver = new IntersectionObserver((entries) => {
            entries.forEach(({ target, isIntersecting }) => {
                const isPreviousButton = target === firstTab;
                if (isPreviousButton) {
                    setIsPreviousButtonDisabled(isIntersecting);
                }
                else {
                    setIsNextButtonDisabled(isIntersecting);
                }
            });
        }, options);
        firstTabIntersectionObserver.observe(firstTab);
        firstTabIntersectionObserver.observe(lastTab);
        return () => {
            firstTabIntersectionObserver.unobserve(firstTab);
            firstTabIntersectionObserver.unobserve(lastTab);
        };
    }, [tabBarRef, tabsRef]);
    return { isPreviousButtonDisabled, isNextButtonDisabled };
};
